<template>
  <div :style="cellsGridStyle" class="cells-grid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppCellsGrid',
  props: {
    columns: {
      type: Number,
      required: true,
      validator(value) {
        return value > 0
      }
    },
    gap: {
      type: String,
      default: '20px'
    },
    marginTop: { type: [String, Number] },
    marginBottom: { type: [String, Number], default: '20px' },
  },
  computed: {
    cellsGridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.columns}, 1fr)`,
        gap: this.gap,
        marginTop: this.normalizeSize(this.marginTop),
        marginBottom: this.normalizeSize(this.marginBottom),
      }
    }
  },
  methods: {
    normalizeSize(value) {
      return typeof value === 'number' ? `${value}px` : value
    },
  }
}
</script>

<style lang="sass" scoped>
.cells-grid
  display: grid
  align-items: center
  width: 100%

</style>